import React, { useEffect, useState } from "react";

const WHATSAPP_URL =
  "https://wa.me/5516997502577?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20o%20PawSuite.";

/** WhatsApp sempre à mão + voltar ao topo depois da primeira dobra. */
const FloatingActions = () => {
  const [showTop, setShowTop] = useState(false);
  const [showLabel, setShowLabel] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > window.innerHeight * 1.2);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Convida uma vez, discretamente, depois some
  useEffect(() => {
    const show = setTimeout(() => setShowLabel(true), 4500);
    const hide = setTimeout(() => setShowLabel(false), 11000);
    return () => {
      clearTimeout(show);
      clearTimeout(hide);
    };
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Voltar ao topo"
        className={`flex h-11 w-11 items-center justify-center rounded-full border border-midnight/10 bg-white/80 text-midnight shadow-lift backdrop-blur-md transition-all duration-500 hover:bg-white ${
          showTop
            ? "pointer-events-auto translate-y-0 opacity-100"
            : "pointer-events-none translate-y-3 opacity-0"
        }`}
      >
        <svg
          className="h-5 w-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>

      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar no WhatsApp"
        onMouseEnter={() => setShowLabel(true)}
        onMouseLeave={() => setShowLabel(false)}
        className="group relative flex items-center gap-3 rounded-full bg-[#25D366] py-3.5 pl-4 pr-4 text-white shadow-[0_16px_40px_-10px_rgba(37,211,102,.7)] transition-all duration-500 hover:scale-105"
      >
        <span className="absolute inset-0 -z-10 rounded-full bg-[#25D366] animate-pulse-ring" />

        <svg className="h-6 w-6 shrink-0" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.38-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.86 9.86 0 004.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2z" />
        </svg>

        <span
          className={`overflow-hidden whitespace-nowrap text-sm font-bold transition-all duration-500 ${
            showLabel ? "max-w-[180px] opacity-100" : "max-w-0 opacity-0"
          }`}
        >
          Fale com a gente
        </span>
      </a>
    </div>
  );
};

export default FloatingActions;
